import { LAYOUTS, } from '@voltmoney/types';
import { StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, } from './types';
import { enhanceLimit, getCollateral, getURL, goBack, navigation, verifyOtp, needHelp, inProgressProcessNavigateAction } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import { getContactUsDetails, removeUrlWithoutReload } from '../../../configs/utils';
import { QUERY_PARAMS, TARGET_PAGES } from '../../../configs/constants';
import sharedPropsService from "../../../SharedPropsService";
export const template = (creditStatus, isAllowed, platform, height, creditAmount, sanctionedLimit, totalOutstanding, userData, pledgedData, isFromPledgeHistory, fromInProgressProcess, contactUsDetails, isFromJupiter, isLoanExpired, netPayable) => {
    return {
        layout: {
            id: ROUTE.FORECLOSURE,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "manageLimit", type: WIDGET.LOAN_FORECLOSURE }
            ],
        },
        datastore: {
            headerStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: 'headerStackTitleStack', type: WIDGET.STACK },
                    { id: 'headerStackSpace0', type: WIDGET.SPACE },
                    { id: 'headerStackDivider', type: WIDGET.DIVIDER }
                ]
            },
            manageLimit: {
                height: height,
                creditLimit: creditAmount,
                backAction: {
                    type: ACTION.MENU,
                    payload: { id: 'bt_loanForeclosure_goBack' },
                    routeId: ROUTE.FORECLOSURE,
                },
                skipBankAction: {
                    type: ACTION.GET_COLLATERAL,
                    routeId: ROUTE.FORECLOSURE,
                },
                pledgedData: pledgedData,
                userData: userData,
                applyAction: {
                    type: ACTION.ENHANCE_LIMIT,
                    routeId: ROUTE.FORECLOSURE,
                },
                continuePress: {
                    routeId: ROUTE.FORECLOSURE,
                    type: ACTION.MARGIN_CALL,
                    payload: {}
                },
                sanctionedAmount: sanctionedLimit,
                totalOutstanding: totalOutstanding,
                needHelp: {
                    routeId: ROUTE.FORECLOSURE,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_loanForeclosure_needHelp' }
                },
                error: false,
                loading: false,
                inProgressProcessNavigateAction: {
                    type: ACTION.INPROGRESS_PROCESS_NAVIGATE,
                    routeId: ROUTE.FORECLOSURE,
                    payload: {}
                },
                processInProgressData: "",
                description: "",
                inProgressType: "",
                isFromPledgeHistory: isFromPledgeHistory || fromInProgressProcess,
                contactUsDetails: contactUsDetails,
                isFromJupiter: isFromJupiter,
                isLoanExpired,
                netPayable,
            },
        },
    };
};
export const loanForeclosure = {
    onLoad: async ({ getHeight, instrumentTrack, removeWidgets, network }, { target, isFromPledgeHistory, fromInProgressProcess }) => {
        const creditStatus = await SharedPropsService.getCreditStatus();
        const user = await SharedPropsService.getUser();
        const isLoanExpired = await SharedPropsService.getIsLoanExpired();
        const foreclosureDetails = await SharedPropsService.getForeClosureDetails();
        const netPayable = foreclosureDetails?.netPayable;
        console.log(foreclosureDetails, "skm123");
        removeWidgets(ROUTE.FORECLOSURE, [
            { id: "manageLimit", type: WIDGET.LOAN_FORECLOSURE }
        ]);
        let totalOutstanding = parseInt(user.linkedCredits[0].principalOutStandingAmount) + user.linkedCredits[0].outstandingInterestDue || 0 + user.linkedCredits[0].chargesDue || 0 + user.linkedCredits[0].penalInterestDue || 0;
        let sanctionedLimit = user.linkedCredits[0].renewalDate;
        const requestOptions = {
            method: 'GET',
            headers: await getAppHeader(),
        };
        if (target && target === TARGET_PAGES.MANAGE_LIMIT) {
            removeUrlWithoutReload(QUERY_PARAMS.TARGET);
        }
        let pledgedData = [];
        let creditAmount = user.linkedCredits[0].availableCreditAmount;
        instrumentTrack('FORECLOSURE_LANDING_PAGE_VIEWED');
        const contactUsDetails = await getContactUsDetails();
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
        let collateralResponse;
        let creditResponse;
        if (isLoanExpired) {
            collateralResponse = await network
                .get(`${api.getCollateral}${user.linkedCredits[0].creditId}`, requestOptions);
            // creditResponse = await network
            // .get(
            //     `${api.getForeclosureDetails}${user.linkedCredits[0].creditId}`,
            //     requestOptions,
            // )
            if (collateralResponse.status === 200) {
                pledgedData = collateralResponse.data || [];
                // bankData: creditResponse
            }
        }
        const platform = await sharedPropsService.getAppPlatform();
        return Promise.resolve(template(creditStatus, true, platform, getHeight(), creditAmount, sanctionedLimit, parseInt(totalOutstanding), user, pledgedData, isFromPledgeHistory, fromInProgressProcess, contactUsDetails, isFromJupiter, isLoanExpired, netPayable));
    },
    actions: {
        [ACTION.EMAIL]: getURL,
        [ACTION.NAVIGATION]: navigation,
        [ACTION.MENU]: goBack,
        [ACTION.ENHANCE_LIMIT]: enhanceLimit,
        [ACTION.MARGIN_CALL]: verifyOtp,
        [ACTION.GET_COLLATERAL]: getCollateral,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.INPROGRESS_PROCESS_NAVIGATE]: inProgressProcessNavigateAction,
        [ACTION.GOT_IT_HANDLE]: inProgressProcessNavigateAction,
    },
};
